'use strict';

var _ = require('lodash');
var SimpleGridController = function SimpleGridController($scope, columnUtils, formattersService, renderersService) {
  $scope.sortColumn = [];
  $scope.sortOrder = [];
  $scope.sortReverse = false;
  $scope.headerCheckboxSelected = false;
  $scope.featureEnabled = function (feature) {
    return $scope.settings && $scope.settings[feature];
  };
  $scope.updateModel = function () {
    if (!$scope.dynamicColumns && $scope.customDisplayModel) {
      $scope.displayModel = $scope.customDisplayModel;
      $scope.renderGrid();
    }
  };
  $scope.getDisplayModelFromColumns = function () {
    if (!$scope.customDisplayModel && $scope.dynamicColumns) {
      $scope.displayModel = columnUtils.createDisplayModel($scope.dynamicColumns);
      $scope.renderGrid();
    }
  };
  $scope.$watch('dynamicColumns', $scope.getDisplayModelFromColumns);
  $scope.$watch('customDisplayModel', $scope.updateModel);
  $scope.$watch('settings', function () {
    if ($scope.settings) {
      $scope.renderGrid();
    }
  });
  $scope.$watch('data', function () {
    if ($scope.data) {
      $scope.renderGrid();
    }
  });
  $scope.isRowVisible = function (row, group) {
    return row.groupingStartRow || !group.isCollapsed;
  };
  $scope.renderRowValue = function (row, rowColumn, rowIndex) {
    var formatFunc = formattersService.getFormatterFor(rowColumn.type);
    var renderFunc = renderersService.getRendererFor(rowColumn.renderer);
    var result = row[rowColumn.field];
    if (_.isFunction(formatFunc)) {
      result = formatFunc(result, rowColumn.format);
    }
    if (_.isFunction(renderFunc)) {
      result = renderFunc(result, row, rowIndex);
    }
    return result;
  };
  $scope.renderCheckBox = function (groupIndex, isChecked, row) {
    var renderFunc = renderersService.getRendererFor('row_selection_checkbox');
    if (_.isFunction(renderFunc)) {
      return renderFunc(groupIndex, isChecked, row);
    }
  };
  $scope.getCustomRowClass = function (row) {
    var result = [];
    if (row.customRowClasses && row.customRowClasses.length) {
      result = result.concat(row.customRowClasses);
    }
    if (row.isSelectedCompetitor && !row.selected) {
      result = result.concat('show-selected-competitor');
    }
    if (row.selected || $scope.headerCheckboxSelected) {
      result.push('selected-row');
    }
    if (!row.selected && !$scope.headerCheckboxSelected) {
      var index = _.indexOf(result, 'selected-row');
      if (index !== -1) {
        result.splice(index, 1);
      }
    }
    return result.join(' ');
  };
  $scope.getCustomCellClass = function (row, rowColumn) {
    var customClassList = row.customCellClasses && row.customCellClasses[rowColumn.field];
    return rowColumn.field + (customClassList ? ' ' + customClassList.join(' ') : '');
  };
  $scope.getCustomGroupHeaderCellClass = function (row, rowColumn, group) {
    if (group && group.isCollapsed) {
      var customGroupClassList = row.customGroupHeaderCellClasses && row.customGroupHeaderCellClasses[rowColumn.field];
      return rowColumn.field + (customGroupClassList ? ' ' + customGroupClassList.join(' ') : '');
    }
    return '';
  };
  $scope.getColumnHeaderClass = function (column) {
    var result = '';
    if ($scope.featureEnabled('sorting') && !column.columns) {
      result = result + ' sortable';
    }
    return result;
  };
  $scope.displayIcons = function (column) {
    return !column.columns && $scope.sortColumn.indexOf(column.field) !== -1;
  };
  $scope.sortByColumn = function (column) {
    if ($scope.featureEnabled('sorting') && column && column.field) {
      if ($scope.sortColumn.indexOf(column.field) === -1) {
        $scope.sortColumn = [column.field];
        $scope.sortOrder = [];
        $scope.sortReverse = false;
      } else if ($scope.sortReverse) {
        $scope.sortColumn = [];
        $scope.sortReverse = false;
      } else {
        $scope.sortOrder = ['desc'];
        $scope.sortReverse = true;
      }
      $scope.data = _.orderBy($scope.data, $scope.sortColumn, $scope.sortOrder);
      $scope.renderGrid();
    }
  };
  $scope.selectDeselectAll = function () {
    $scope.headerCheckboxSelected = !$scope.headerCheckboxSelected;
  };
};
SimpleGridController.$inject = ['$scope', 'SimpleGridColumnUtilsService', 'SimpleGridFormattersService', 'SimpleGridRenderersService'];
module.exports = SimpleGridController;